import { Menu, X } from 'lucide-react';
import { useEffect, useState } from 'react';



export default function Navigation({ currentPage, onNavigate }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  const menuItems = [
    { name: 'Home', id: '/' },
    { name: 'Biography', id: 'biography' },
    // { name: 'Books', id: 'books' },
    // { name: 'Ministries', id: 'ministries' },
    { name: 'Contact', id: 'contact' },
  ];

  const handleNavigate = (page) => {
    // onNavigate(page);
    window.location.href = page
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 pt-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <button
            onClick={() => handleNavigate('home')}
            className="text-xl bg-white/50 backdrop-blur-2xl p-2 rounded-xl font-semibold text-gray-800 hover:text-amber-700 transition-colors duration-300"
          >
            Latangela Rogers
          </button>

          <div className="hidden md:flex space-x-8 bg-white/80 backdrop-blur-xl p-5 rounded-xl">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavigate(item.id)}
                className={`text-sm font-medium transition-all duration-300 ${currentPage === item.id
                  ? 'text-amber-700 border-b-2 border-amber-700'
                  : 'text-gray-600 hover:text-amber-700'
                  }`}
              >
                {item.name}
              </button>
            ))}
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-600 hover:text-amber-700 transition-colors duration-300"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t animate-fade-in">
          <div className="px-4 py-4 space-y-3">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavigate(item.id)}
                className={`block w-full text-left px-4 py-2 rounded-lg transition-all duration-300 ${currentPage === item.id
                  ? 'bg-amber-100 text-amber-700 font-medium'
                  : 'text-gray-600 hover:bg-gray-50'
                  }`}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
